import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Styles from './styles';

const Label = props => <div style={{ ...Styles.wrapper, ...props.style }}>{props.children}</div>;

Label.propTypes = {
  style: StylePropType,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

Label.defaultProps = {
  style: {},
  children: [],
};

export default Label;



// WEBPACK FOOTER //
// ./src/components/UIKit/Label/index.js